import React from 'react';
import PropTypes from 'prop-types';
import MuiSlider from '@mui/material/Slider';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('EstatePlanningManagementPageStepProgress', (theme) => ({
  root: {
    padding: theme.spacing(3, 0, 2),
  },
  sliderRoot: {
    '&.Mui-disabled': {
      height: theme.spacing(1.25),
      padding: 0,
      borderRadius: 9999, // Full rounding
    },
    '& .MuiSlider-valueLabelOpen.FD-MuiSlider-valueLabel': {
      backgroundColor: theme.palette.success.main,
      fontSize: theme.typography.caption.fontSize,
      borderRadius: 8,
    },
  },
  sliderTrack: {
    '&.FD-MuiSlider-track': {
      border: 'none',
      backgroundColor: theme.palette.success.main,
    },
  },
  sliderThumb: {
    '&.Mui-disabled': {
      width: 0,
      height: 0,
    },
  },
}));

export const EstatePlanningManagementPageStepProgress = ({ stepResource, currStep, totalSteps }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <MuiSlider
        {...dataAttrs('estate-planning-progress')}
        classes={{
          root: classes.sliderRoot,
          track: classes.sliderTrack,
          thumb: classes.sliderThumb,
        }}
        disabled
        defaultValue={currStep}
        min={0}
        max={totalSteps}
        valueLabelDisplay={'on'}
        valueLabelFormat={() => stepResource.attr('title')}
      />
    </div>
  );
};

EstatePlanningManagementPageStepProgress.propTypes = {
  stepResource: PropTypes.object.isRequired,
  currStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};
